<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full">
			<ul class="ul-area">
				<li class="mt-3">
					<vs-radio v-model="status" vs-value="frequencyHour">{{ $t("TimeWindow.EveryHour") }}</vs-radio>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="rangeHour">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.Every") }} </span>
									<vs-select
										autocomplete
										v-model="numberHour"
										width="60px"
										class="ml-1"
										:disabled="status !== 'rangeHour'"
										:input-changed="getResultHour"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in hourList"
										/>
									</vs-select>
									<span class="ml-1">{{
										($t("TimeWindow.HourStartingAtHour") + " ") | lowerCase
									}}</span>
									<vs-select
										autocomplete
										v-model="numberHourTwo"
										width="70px"
										class="ml-1"
										:disabled="status !== 'rangeHour'"
										:input-changed="getResultHour"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in hourNumberList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="choiceHour">{{
								$t("TimeWindow.SpecificHour")
							}}</vs-radio>
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-select
										autocomplete
										multiple
										v-model="selectHour"
										width="100%"
										:disabled="status !== 'choiceHour'"
										:input-changed="getResultHour"
										@input="selectHour.sort()"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in hourNumberList"
										/>
									</vs-select>
								</div>
							</div>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="betweenHour">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.EveryHourBetweenHour") }} </span>
									<vs-select
										autocomplete
										v-model="rangeHourInit"
										width="60px"
										class="ml-1"
										:disabled="status !== 'betweenHour'"
										:input-changed="getResultHour"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in hourNumberList"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.And") + " ") | lowerCase }}</span>
									<vs-select
										autocomplete
										v-model="rangeHourEnd"
										width="60px"
										class="ml-1"
										:disabled="status !== 'betweenHour'"
										:input-changed="getResultHour"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in hourNumberList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "Hourly",
	data() {
		return {
			status: "choiceHour",
			numberHour: 1,
			rangeHourInit: 0,
			rangeHourEnd: 0,
			numberHourTwo: 0,
			selectHour: [0],
		};
	},
	props: {
		cronExpressionHour: {
			type: String,
			default: "",
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getResultHour() {
			let result = "";
			switch (this.status) {
				case "frequencyHour":
					result = "*";
					break;
				case "rangeHour":
					result = `${this.numberHourTwo}/${this.numberHour}`;
					break;
				case "choiceHour":
					result = `${this.selectHour.join(",")}`;
					break;
				case "betweenHour":
					result = `${this.rangeHourInit}-${this.rangeHourEnd}`;
					break;
			}
			this.$emit("resultHourEmit", result);
			return result;
		},
		hourList() {
			let hour = [];
			for (let i = 1; i <= 24; i++) {
				hour.push({text: i, value: i});
			}
			return hour;
		},
		hourNumberList() {
			let number = [];
			for (let i = 0; i < 24; i++) {
				number.push({text: i.toString().length > 1 ? `${i}` : `0${i}`, value: i});
			}
			return number;
		},
	},
	mounted() {
		if (
			this.cronExpressionHour !== " " &&
			this.cronExpressionHour !== null &&
			this.cronExpressionHour !== undefined &&
			this.isEdit
		) {
			if (this.cronExpressionHour.includes("*")) {
				this.status = "frequencyHour";
			} else if (this.cronExpressionHour.includes("/")) {
				this.numberHourTwo = this.cronExpressionHour.split("/")[0];
				this.numberHour = this.cronExpressionHour.split("/")[1];
				this.status = "rangeHour";
			} else if (this.cronExpressionHour.includes("-")) {
				this.rangeHourInit = this.cronExpressionHour.split("-")[0];
				this.rangeHourEnd = this.cronExpressionHour.split("-")[1];
				this.status = "betweenHour";
			} else {
				if (this.cronExpressionHour.includes(",")) {
					this.selectHour = this.cronExpressionHour.split(",").map((hour) => parseInt(hour));
				} else {
					this.selectHour = [parseInt(this.cronExpressionHour)];
				}
				this.status = "choiceHour";
			}
		}
	},
};
</script>
<style lang="scss">
.form-inline {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-flow: row wrap;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}
.specific-check {
	display: flex;
	flex-wrap: wrap;
	padding-left: 20px;
}
.check-week {
	padding: 10px 0px 10px 0px;
}
.vs-radio--input + .vs-radio + .vs-radio--label {
	color: #ababab;
	cursor: pointer;
}
.vs-radio--input:checked + .vs-radio + .vs-radio--label {
	color: #000;
}
</style>
